export default "__VITE_ASSET__2036ce4b__"